export const PUB_DATE_VAL = "publicationDate";
export const CITATIONS_VAL = "citationCount";
export const RELEVANCE_VAL = null;

const PUB_DATE_LABEL = "Publication Date";
const CITATIONS_LABEL = "Citations";
const RELEVANCE_LABEL = "Relevance";

const PUB_DATE_OPTION = { val: PUB_DATE_VAL, label: PUB_DATE_LABEL };
const CITATIONS_OPTION = { val: CITATIONS_VAL, label: CITATIONS_LABEL };
const RELEVANCE_OPTION = { val: RELEVANCE_VAL, label: RELEVANCE_LABEL };

export const SORT_VAL_DICT = {
  [PUB_DATE_VAL]: PUB_DATE_LABEL,
  [CITATIONS_VAL]: CITATIONS_LABEL,
  [RELEVANCE_VAL]: RELEVANCE_LABEL,
};

export const SORT_OPTIONS_REL = [
  RELEVANCE_OPTION,
  PUB_DATE_OPTION,
  CITATIONS_OPTION,
];

export const SORT_OPTIONS_NO_REL = [PUB_DATE_OPTION, CITATIONS_OPTION];

export const SORT_OPTION_DICT = {
  [PUB_DATE_VAL]: PUB_DATE_OPTION,
  [CITATIONS_VAL]: CITATIONS_OPTION,
  [RELEVANCE_VAL]: RELEVANCE_OPTION,
};
